const FIXED_WIDTH_CLASS = '!gl-w-31';
const DEFAULT_OFFSET = 8;
const ARROW_X_MINIMUM = 24;

export { ARROW_X_MINIMUM, DEFAULT_OFFSET, FIXED_WIDTH_CLASS };
